import { render, staticRenderFns } from "./AlarmClassification.vue?vue&type=template&id=10a6c847&scoped=true"
import script from "./AlarmClassification.vue?vue&type=script&lang=js"
export * from "./AlarmClassification.vue?vue&type=script&lang=js"
import style0 from "./AlarmClassification.vue?vue&type=style&index=0&id=10a6c847&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a6c847",
  null
  
)

export default component.exports